import IB_Preset from '@bo-ibSheet/common';

const GRID_COL_PRESET = {
  ORDER_NUMBER: {
    Type: 'Text',
    CustomFormat: (value) =>
      value.length === 16 ? value.substr(0, 9) + '-' + value.substr(9) : value.substr(0, 8) + '-' + value.substr(8),
    MinWidth: 176,
    Width: 176,
    Align: 'Left',
    ColMerge: true,
    CanEdit: false,
    CanSort: 0,
    TextStyle: 0,
  },
  ORDER_DETAIL_NUMBER: {
    Type: 'Text',
    CustomFormat: '###############',
    Width: 150,
    MinWidth: 150,
    Align: 'Center',
    ColMerge: false,
    CanEdit: false,
    CanSort: 0,
  },
  DELIVERY_NUMBER: {
    Type: 'Text',
    Width: 160,
    MinWidth: 160,
    Align: 'Left',
    ColMerge: false,
    CanEdit: false,
    CanSort: 0,
    TextStyle: 0,
  },
  DELIVERY_SEQUENCE: {
    Type: 'Text',
    Width: 80,
    MinWidth: 80,
    Align: 'Center',
    ColMerge: false,
    CanEdit: false,
    CanSort: 0,
  },
  GOOD_NUMBER: {
    Type: 'Text',
    Width: 120,
    MinWidth: 120,
    Align: 'Left',
    ColMerge: false,
    CanEdit: false,
    CanSort: 0,
    TextStyle: 0,
  },
  GOOD_NAME: {
    Type: 'Text',
    RelWidth: true,
    MinWidth: 300,
    Align: 'Left',
    ColMerge: false,
    CanEdit: false,
    CanSort: 0,
  },
  ITEM_NAME: {
    Type: 'Text',
    RelWidth: true,
    MinWidth: 200,
    Align: 'Left',
    ColMerge: false,
    CanEdit: false,
    CanSort: 0,
  },
  QUANTITY: {
    ...IB_Preset.Integer,
    Width: 100,
    MinWidth: 100,
    Format: '#,##0개',
    ColMerge: false,
    CanEdit: false,
    CanSort: 0,
  },
  CURRENCY_W112: {
    ...IB_Preset.Currency,
    MinWidth: 112,
    Width: 112,
    ColMerge: false,
    CanEdit: false,
    CanSort: 0,
  },
  CURRENCY_W140: {
    ...IB_Preset.Currency,
    MinWidth: 140,
    Width: 140,
    ColMerge: false,
    CanEdit: false,
    CanSort: 0,
  },
  PERCENT_W140: {
    ...IB_Preset.Percent,
    MinWidth: 140,
    Width: 140,
    ColMerge: false,
    CanEdit: false,
    CanSort: 0,
  },
  DAYS: {
    ...IB_Preset.Integer,
    Format: '#,##0일',
    MinWidth: 80,
    Width: 80,
    CanEdit: false,
    ColMerge: false,
    CanSort: 0,
  },
  YMD: {
    ...IB_Preset.YMD,
    MinWidth: 98,
    Width: 98,
    CanEdit: false,
    EmptyValue: '',
    ColMerge: false,
    CanSort: 0,
  },
  YMDHM: {
    ...IB_Preset.YMDHM,
    EmptyValue: '',
    MinWidth: 140,
    Width: 140,
    CanEdit: false,
    DataFormat: 'yyyyMMddHHmmss',
    ColMerge: false,
    CanSort: 0,
  },
  VENDOR_NAME: {
    Type: 'Text',
    MinWidth: 200,
    Width: 200,
    CanEdit: false,
    ColMerge: false,
    TextStyle: 0,
    CanSort: 0,
  },
  USER_NAME: {
    Type: 'Text',
    MinWidth: 100,
    Width: 100,
    CanEdit: false,
    ColMerge: false,
    CanSort: 0,
  },
  PHONE_NUMBER: {
    Type: 'Text',
    MinWidth: 112,
    Width: 112,
    Align: 'Center',
    CanEdit: false,
    ColMerge: false,
    CanSort: 0,
  },
  ORDERER_NAME: {
    Type: 'Html',
    MinWidth: 126,
    Width: 126,
    ColMerge: false,
    Formula: ({ Row }) => {
      return `
          <div style='width: 100%; display: flex; align-items: center;'>
            <div style='overflow: hidden; text-overflow: ellipsis; white-space: nowrap; flex-wrap: nowrap; padding: 6px 0 5px 0'>
              ${Row['ordererName']}
            </div>
            ${
              Row['vipYn'] === 'Y'
                ? `<div style='display: inline-flex; align-items: center; justify-content: center; flex-shrink: 0; margin-left: 6px; width: 26px; height: 16px; background-color: #6C60FF; border-radius: 16px; color: #FFFFFF; font-weight: 700; font-size: 10px;'>VIP</div>`
                : ''
            }
          </div>`;
    },
    CanEdit: false,
    CanSort: 0,
  },
  ORDERER_ID: {
    Type: 'Text',
    MinWidth: 112,
    Width: 112,
    Align: 'Center',
    CanEdit: false,
    ColMerge: false,
    CanSort: 0,
  },
  ADDRESS: {
    Type: 'Text',
    RelWidth: true,
    MinWidth: 300,
    CanEdit: false,
    ColMerge: false,
    CanSort: 0,
  },
  MEMO: {
    Type: 'Text',
    RelWidth: true,
    MinWidth: 300,
    CanEdit: false,
    ColMerge: false,
    CanSort: 0,
  },
  PARCEL_COMPANY: {
    Type: 'Text',
    Width: 140,
    MinWidth: 140,
    CanEdit: false,
    ColMerge: false,
    CanSort: 0,
  },
  INVOICE: {
    Type: 'Text',
    Width: 108,
    MinWidth: 108,
    Align: 'Center',
    CanEdit: false,
    ColMerge: false,
    CanSort: 0,
  },
  SITE_NAME: {
    Type: 'Text',
    MinWidth: 110,
    Width: 110,
    Align: 'Center',
    CanEdit: false,
    ColMerge: false,
  },
  MEMBER_NUMBER: {
    Type: 'Text',
    MinWidth: 150,
    Width: 150,
    Align: 'Center',
    CanEdit: false,
    ColMerge: false,
  },
  LOGIN_ID: {
    Type: 'Text',
    MinWidth: 80,
    Width: 80,
    Align: 'Center',
    CanEdit: false,
    ColMerge: false,
  },
};

export default GRID_COL_PRESET;
